import { Component, inject } from '@angular/core';
import { RedirectService, StoreFinderFacade } from '@boels/shared-state';
import { combineLatest, map, Observable, switchMap } from 'rxjs';
import { Region, StoreFinderSearchPage } from '@boels/models';
import { StoreFinderListMapComponent } from '../store-finder-list-map/store-finder-list-map.component';
import { RoutingService, UrlSafePipe } from '@boels/helpers';
import { Params } from '@angular/router';
import { StoreFinderSearchComponent } from '../store-finder-search/store-finder-search.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpStatusCode } from '@angular/common/http';

@Component({
  selector: 'boels-store-finder-region-result',
  templateUrl: './store-finder-region-result.component.html',
  styleUrls: ['./store-finder-region-result.component.scss'],
  imports: [StoreFinderListMapComponent, StoreFinderSearchComponent],
})
export class StoreFinderRegionResultComponent {
  #storeFinderFacade = inject(StoreFinderFacade);
  #urlSafePipe = inject(UrlSafePipe);
  #routingService = inject(RoutingService);
  #redirectService = inject(RedirectService);

  stores$: Observable<StoreFinderSearchPage> = combineLatest([
    this.#routingService.getRoutePropertyAsObservable('params'),
    this.#routingService.getRoutePropertyAsObservable('queryParams'),
    this.#storeFinderFacade.getStoresByRegion(),
  ]).pipe(
    takeUntilDestroyed(),
    switchMap(
      ([params, queryParams, stores]: [
        Params | undefined,
        Params | undefined,
        Region[],
      ]) => {
        const specialism = queryParams?.['specialism'];
        const region = params?.['region'];

        // Redirect to branches if region is not part of basestore
        if (
          !stores.some(
            (store: Region) =>
              this.#urlSafePipe.transform(store.name)?.toLocaleLowerCase() ===
              region.toLocaleLowerCase(),
          )
        ) {
          this.#redirectService.setStatusCode(HttpStatusCode.NotFound);
        }

        return this.#storeFinderFacade
          .getPointOfServicesByQuery('', -1, specialism)
          .pipe(
            map((storeFinderSearchPage: StoreFinderSearchPage) => {
              const tempStoreFinderSearchPage: StoreFinderSearchPage = {
                ...storeFinderSearchPage,
              };
              if (storeFinderSearchPage.stores?.length) {
                tempStoreFinderSearchPage.stores =
                  storeFinderSearchPage.stores?.filter((store) => {
                    this.#storeFinderFacade.setActiveRegion(region);
                    return (
                      this.#urlSafePipe.transform(
                        store?.address?.region?.name,
                      ) === region
                    );
                  });
              } else {
                this.#storeFinderFacade.setActiveRegion('');
              }
              return tempStoreFinderSearchPage;
            }),
          );
      },
    ),
  );
}
